export default "__VITE_ASSET__BwoBQG_1__"